import { calculateSecondsToMinutes } from '@/utils/helpers';
import styles from '../verification-form.module.scss';
import useTimer from '@/hooks/use-timer/use-timer';
import { Flex } from 'antd';
import { Button } from '@/components/button/button';

interface VerificationTimerProps {
  duration?: number;
  onResendCode: () => void;
  codeResent?: boolean;
}

export default function VerificationTimer({
  duration = 180,
  onResendCode,
  codeResent = false,
}: VerificationTimerProps) {
  const handleSendNewCode = () => {
    setTimeLeft(duration);
    onResendCode();
  };

  const { timeLeft, setTimeLeft } = useTimer(duration);
  return (
    <Flex vertical>
      <p>Didn't receive the verification code?</p>
      <Flex align="center" className={styles.linkContainer}>
        {timeLeft > 0 || codeResent ? (
          <p>Send new code in {calculateSecondsToMinutes(timeLeft)}</p>
        ) : (
          <Button buttonVariant="link" onClick={handleSendNewCode} disabled={timeLeft > 0 || codeResent}>
            Send new code
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
